/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface SystemContextInput
 */
export interface SystemContextInput {
    /**
     * 
     * @type {Array<string>}
     * @memberof SystemContextInput
     */
    agencies?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SystemContextInput
     */
    agencyGroups?: Array<string> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof SystemContextInput
     */
    channels?: Array<number> | null;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof SystemContextInput
     */
    brandAndMarket?: BrandAndMarketListItem;
}

export function SystemContextInputFromJSON(json: any): SystemContextInput {
    return SystemContextInputFromJSONTyped(json, false);
}

export function SystemContextInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): SystemContextInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'agencies': !exists(json, 'agencies') ? undefined : json['agencies'],
        'agencyGroups': !exists(json, 'agencyGroups') ? undefined : json['agencyGroups'],
        'channels': !exists(json, 'channels') ? undefined : json['channels'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
    };
}

export function SystemContextInputToJSON(value?: SystemContextInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'agencies': value.agencies,
        'agencyGroups': value.agencyGroups,
        'channels': value.channels,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
    };
}


